import { getJobList } from './GetJobList';

/**
 * Jobs Service
 * Provides business logic layer for jobs operations
 */
export const JobsService = {
  getJobList,
};
